import { Pipe, PipeTransform } from '@angular/core';
import { Slot } from '@/reservation/reservation.model';

@Pipe({
	name: 'userDocumentNumbers',
	standalone: true,
	pure: true,
})
export class UserDocumentNumbersPipe implements PipeTransform {
	transform(slot: Slot | null | undefined): string {
		const docs = slot?.userData?.userDocuments ?? [];
		return docs
			.map((doc) => doc.number)
			.filter((number) => !!number?.trim())
			.join(', ');
	}
}
